// extracted by mini-css-extract-plugin
export var chevron = "_2c-2";
export var chevronCollapsed = "_2c-3";
export var collapsibleHeader = "_2c-1";
export var container = "_2c-0";